 import {
  faUser,
  faCog,
  faHome,
  faBuilding,
  faUsers,
  faClipboardList,
  faCogs,
  faChartLine,
  faTools,
  faCheckCircle,
  faFileAlt,
  faUserTie,
  faUserShield,
  faUserCog,
  faUserFriends,
  faUserCheck,
  faComments
} from '@awesome.me/kit-269fbef2e2/icons/duotone/solid';

export const MSG_TABS = [
  { 
    label: 'Overview', 
    key: 'overview', 
    icon: faHome,
  },
  { 
    label: 'Context', 
    key: 'context', 
    icon: faBuilding,
    items: [
      { label: 'Internal and External Issues', key: 'context.issues', icon: faFileAlt },
      { label: 'Interested Parties', key: 'context.parties', icon: faUsers },
      { label: 'Scope', key: 'context.scope', icon: faClipboardList },
      { label: 'MMS', key: 'context.mms', icon: faBuilding },
      { label: 'Legal Obligations', key: 'context.legal', icon: faFileAlt },
      { label: 'Special Interest Groups', key: 'context.groups', icon: faUsers },
    ] 
  },
  { 
    label: 'Leadership', 
    key: 'leadership', 
    icon: faUserTie,
    items: [
      { label: 'Leadership & Commitment', key: 'leadership.commitment', icon: faUserCheck },
      { label: 'Policy', key: 'leadership.policy', icon: faFileAlt },
      { label: 'Roles', key: 'leadership.roles', icon: faUserCog },
    ] 
  },
  { 
    label: 'Planning', 
    key: 'planning', 
    icon: faClipboardList,
    items: [
      { label: 'General', key: 'planning.general', icon: faFileAlt },
      { label: 'Risk Assessment', key: 'planning.risk-assessment', icon: faUserShield },
      { label: 'Risk Treatment', key: 'planning.risk-treatment', icon: faUserShield },
      { label: 'Objectives', key: 'planning.objectives', icon: faCheckCircle },
      { label: 'Changes', key: 'planning.changes', icon: faTools },
    ] 
  },
  { 
    label: 'Support', 
    key: 'support', 
    icon: faTools,
    items: [
      { 
        label: 'Competency', 
        key: 'support.competency', 
        icon: faUserFriends,
        items: [
          { label: 'Overview', key: 'support.competency.overview', icon: faUserFriends },
          { label: 'Top Management', key: 'support.competency.top-management', icon: faUserTie },
          { label: 'Asset Owner', key: 'support.competency.assetOwner', icon: faUserShield },
          { label: 'Business Sponsor', key: 'support.competency.business-sponsor', icon: faUserTie },
          { label: 'User', key: 'support.competency.user', icon: faUser },
        ]
      },
      { label: 'Communication', key: 'support.communication', icon: faComments },
      { label: 'Documentation', key: 'support.documentation', icon: faFileAlt },
      // { label: 'Roles', key: 'support.roles', icon: faUserCog },
    ] 
  },
  { 
    label: 'Operation', 
    key: 'operation', 
    icon: faCogs,
    items: [
      { label: 'Overview', key: 'operation.overview', icon: faCog },
    ]
  },
  { 
    label: 'Performance', 
    key: 'performance', 
    icon: faChartLine,
    items: [
      { label: 'Monitoring', key: 'performance.monitoring', icon: faChartLine },
      { label: 'Internal Audit', key: 'performance.internalaudit', icon: faClipboardList },
      { label: 'Management Review', key: 'performance.managementreview', icon: faUserTie },
    ] 
  },
  { 
    label: 'Improvement', 
    key: 'improvements', 
    icon: faCheckCircle,
  },
];
